export default __webpack_public_path__ + "static/media/teamwork-lower-l.ec8a214e.png";